<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header
          v-if="!this.everythingLoaded"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon class="load-rotate">hourglass_empty</md-icon>
          </div>
          <h4 class="title">Laden</h4>
        </md-card-header>
        <md-card-header
          v-if="this.everythingLoaded"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon>people</md-icon>
          </div>
          <h4 class="title">Gebruikers</h4>
          <div class="md-group" style="float: right">
            <md-button
              class="md-round md-just-icon"
              :class="btnViewTypeListClass"
              @click.native="setViewTypeList()"
              title="Lijst weergave"
              ><md-icon>list</md-icon></md-button
            >
            <md-button
              class="md-round md-just-icon"
              :class="btnViewTypeImageClass"
              @click.native="setViewTypeImage()"
              title="Afbeeldingen weergave"
              ><md-icon>image</md-icon></md-button
            >
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            v-if="this.everythingLoaded && this.viewType === 'list'"
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="sortAll"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Gebruikers per pagina</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <label for="pages">Zichtbare velden</label>
                <md-select
                  v-model="selectedFields"
                  name="fields"
                  id="fields"
                  multiple
                >
                  <md-option
                    v-for="(fieldName, fieldId) in this.getFields()"
                    :key="fieldId"
                    :value="fieldId"
                    >{{ fieldName }}</md-option
                  >
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Zoek gebruikers(s)"
                  v-model="searchQuery"
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                v-for="fieldId in selectedFields"
                :key="item.id + fieldId"
                :class="fieldId === 'email' ? 'cursor-mail' : 'cursor-pointer'"
                @click.native="
                  fieldId === 'email' ? handleMail(item) : handleEdit(item)
                "
                :md-label="getGebruikerFieldLabel(fieldId)"
                :md-sort-by="fieldId"
                >{{ getGebruikerField(item, fieldId) }}</md-table-cell
              >
              <md-table-cell md-label="Verwijderen">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <template v-if="this.everythingLoaded && this.viewType === 'image'">
            <div
              class="gebruikerImagesContainer"
              v-for="item in tableData"
              :key="'image' + item.id"
              @click="handleEdit(item)"
            >
              <div
                class="imagePreview"
                :style="'background-image: url(' + imageUrl(item) + ')'"
              />
              <div class="fullname">{{ getFullUserName(item) }}</div>
            </div>
          </template>
        </md-card-content>
        <md-card-actions
          v-if="this.everythingLoaded && this.viewType === 'list'"
          md-alignment="space-between"
        >
          <div class="">
            <p class="card-category">
              Weergave van {{ from + 1 }} t/m {{ to }} van
              {{ total }} gebruikers
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
          <div>
            <md-button @click.native="exportExcel()" class="md-success">
              <span class="md-label">
                <md-icon class="material-icons">file_download</md-icon>
              </span>
              Exporteren
            </md-button>
          </div>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
    btnViewTypeListClass() {
      return this.viewType === "list" ? "md-success" : "md-default";
    },
    btnViewTypeImageClass() {
      return this.viewType === "image" ? "md-success" : "md-default";
    },
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    }
  },
  data() {
    return {
      currentSort: "lastName",
      currentSortOrder: "asc",
      pagination: {
        perPage: 200,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      footerTable: [
        "Achternaam",
        "Tussenvoegsel",
        "Voornaam",
        "E-mailadres",
        "Rollen",
        "Verwijderen"
      ],
      searchQuery: "",
      propsToSearch: ["firstName", "lastNamePrefix", "lastName", "email"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      allRoles: [],
      allFields: [],
      allFieldTypes: [],
      allowedFieldTypeIds: [],
      viewType: "list",
      selectedFields: ["lastName", "lastNamePrefix", "firstName", "email"],
      loaded: {
        users: false,
        roles: false,
        fields: false,
        fieldTypes: false
      }
    };
  },
  methods: {
    loadUsersRoles() {
      this.loaded.roles = false;
      this.$http.get(this.$apiBaseUrl + "users/roles").then(
        response => {
          this.allRoles = response.data.roles;
          this.loaded.roles = true;
        },
        response => {}
      );
    },
    loadUsersFields() {
      this.loaded.fields = false;
      this.$http.get(this.$apiBaseUrl + "users/fields").then(
        response => {
          this.allFields = response.data.fields;
          this.loaded.fields = true;
        },
        response => {}
      );
    },
    loadUsersFieldTypes() {
      this.loaded.fieldTypes = false;
      this.$http.get(this.$apiBaseUrl + "users/field/types").then(
        response => {
          this.allFieldTypes = response.data.fieldTypes;
          this.loaded.fieldTypes = true;
        },
        response => {}
      );
    },
    loadUsers() {
      this.loaded.users = false;
      this.$http.get(this.$apiBaseUrl + "users").then(
        response => {
          let tableData = response.data.users;

          for (var i = 0; i < tableData.length; i++) {
            if (tableData[i].lastNamePrefix == null) {
              tableData[i].lastNamePrefix = "";
            }

            for (let j in tableData[i].fieldValues) {
              tableData[i][tableData[i].fieldValues[j].field_id] =
                tableData[i].fieldValues[j].value[0];
            }

            delete tableData[i]["fieldValues"];
          }

          this.tableData = this.sortAll(tableData);

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableData, {
            keys: ["firstName", "lastNamePrefix", "lastName", "email"],
            threshold: 0.3
          });

          this.loaded.users = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van gebruikers",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    updateFuseSearch() {
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.selectedFields,
        threshold: 0.3
      });
    },
    getFullUserName(user, nbsp = false) {
      let name =
        user.firstName +
        " " +
        (user.lastNamePrefix != null && user.lastNamePrefix !== ""
          ? user.lastNamePrefix + " "
          : "") +
        user.lastName;

      if (nbsp) {
        name = name.replace(" ", "&nbsp;");
      }

      return name;
    },
    handleEdit(item) {
      this.$router.push("/users/edit/" + item.id);
    },
    handleMail(item) {
      window.location = "mailto:" + item.email;
    },
    handleDelete(item) {
      Swal.fire({
        title: "Weet u het zeker?",
        text: `Gebruiker "${this.getFullUserName(
          item
        )}" wordt uit het systeem verwijderd.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Verwijderen",
        cancelButtonText: "Annuleren",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$http.delete(this.$apiBaseUrl + "users/" + item.id).then(
            response => {
              this.deleteRow(item);

              this.notifyVue(
                "Gebruiker succesvol verwijderd",
                "check",
                "success",
                5000
              );

              // Fuse search initialization.
              this.fuseSearch = new Fuse(this.tableData, {
                keys: [
                  "firstName",
                  "lastNamePrefix",
                  "lastName",
                  "email",
                  "rolesString"
                ],
                threshold: 0.3
              });
            },
            response => {
              if (response.status === 403) {
                this.notifyVue(
                  "U heeft geen rechten voor het beheren van gebruikers",
                  "add_alert",
                  "danger",
                  0
                );
              } else if (response.status === 422) {
                this.notifyVue(
                  "U kunt uzelf niet verwijderen",
                  "add_alert",
                  "danger",
                  0
                );
              }
            }
          );
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    setViewTypeList() {
      this.viewType = "list";
    },
    setViewTypeImage() {
      this.viewType = "image";
    },
    imageUrl: function(user) {
      return this.$apiBaseUrl + "../user/" + user.id + "/avatar";
    },
    getFields() {
      let data = {
        lastName: "Achternaam",
        lastNamePrefix: "Tussenvoegsel",
        firstName: "Voornaam",
        email: "E-mail adres"
      };

      if (this.allowedFieldTypeIds.length === 0) {
        let allowedFieldTypes = ["text", "date", "select"];

        for (let i in this.allFieldTypes) {
          if (allowedFieldTypes.indexOf(this.allFieldTypes[i].type) !== -1) {
            this.allowedFieldTypeIds.push(this.allFieldTypes[i].id);
          }
        }
      }

      for (let i in this.allFields) {
        if (
          this.allowedFieldTypeIds.indexOf(this.allFields[i].type_id) === -1
        ) {
          continue;
        }
        data[this.allFields[i].id] = this.allFields[i].name;
      }

      return data;
    },
    getGebruikerField(item, fieldId) {
      return item[fieldId];
    },
    getGebruikerFieldLabel(fieldId) {
      if (fieldId === "lastName") {
        return "Achternaam";
      }
      if (fieldId === "lastNamePrefix") {
        return "Tussenvoegsel";
      }
      if (fieldId === "firstName") {
        return "Voornaam";
      }
      if (fieldId === "email") {
        return "E-mailadres";
      }

      for (let i in this.allFields) {
        if (this.allFields[i].id === fieldId) {
          return this.allFields[i].name;
        }
      }
    },
    exportExcel() {
      this.notifyVue(
        "Export gebruikers download gestart",
        "check",
        "success",
        5000
      );

      let perPage = this.pagination.perPage;
      let currentPage = this.pagination.currentPage;
      this.pagination.currentPage = 1;
      this.pagination.perPage = 1000;

      let data = [];

      for (let rowIndex in this.queriedData) {
        let row = [];
        for (let selectedFieldIndex in this.selectedFields) {
          if (rowIndex === 0) {
            row.push(
              this.queriedData[rowIndex][
                this.selectedFields[selectedFieldIndex]
              ]
            );

            continue;
          }

          row.push(
            this.queriedData[rowIndex][this.selectedFields[selectedFieldIndex]]
          );
        }
        data.push(row);
      }

      let row = [];
      for (let selectedFieldIndex in this.selectedFields) {
        row.push(
          this.getGebruikerFieldLabel(this.selectedFields[selectedFieldIndex])
        );
      }
      data.unshift(row);

      this.pagination.currentPage = currentPage;
      this.pagination.perPage = perPage;

      this.$http
        .post(
          this.$apiBaseUrl + "users/export/xlsx",
          {
            data: data
          },
          {
            responseType: "blob"
          }
        )
        .then(
          response => {
            const filename = response.headers.map["content-disposition"][0]
              .split(";")[1]
              .split("filename")[1]
              .split("=")[1]
              .trim()
              .replaceAll('"', "");
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const fURL = document.createElement("a");

            fURL.href = fileURL;
            fURL.setAttribute("download", filename);
            document.body.appendChild(fURL);
            fURL.click();
            document.body.removeChild(fURL);
          },
          response => {
            this.notifyVue(
              "Fout geconstateerd tijdens exporteren van de gebruikers:<br/>" +
                response.body,
              "report_problem",
              "danger",
              0
            );
          }
        );
    }
  },
  mounted() {
    this.loadUsersRoles();
    this.loadUsersFields();
    this.loadUsersFieldTypes();
    this.loadUsers();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    selectedFields() {
      this.updateFuseSearch();
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-card .md-table-cell.cursor-pointer {
  cursor: pointer;
}
.md-card .md-table-cell.cursor-mail {
  cursor: url("/img/default/pointers/mail.svg"), auto;
}
.md-card-header .md-button + .md-button {
  margin-left: 0;
}
</style>
<style lang="css">
.card-icon .md-icon.md-theme-default.md-icon-image svg {
  fill: #ffffff;
}

div.gebruikerImagesContainer {
  display: inline-block;
  margin: 15px;
  cursor: pointer;
}
div.gebruikerImagesContainer div.imagePreview {
  display: block;
  border: 1px solid #999;
  width: 250px;
  height: 250px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  margin-bottom: 15px;
}

div.gebruikerImagesContainer div.fullname {
  text-align: center;
}
</style>
